export default {
    ASSISTANCE_FEES: 'ASSISTANCE_FEES',
    ESTIMATIONS: 'ESTIMATIONS',
};
